<h6 class="payment-label">Enter your card details</h6>
<div class="col-12 border payment-input py-3" [id]="id"></div>
